import { render } from "./DocumentAuditEvent.vue?vue&type=template&id=3c3714fe&scoped=true"
import script from "./DocumentAuditEvent.vue?vue&type=script&lang=js"
export * from "./DocumentAuditEvent.vue?vue&type=script&lang=js"

import "./DocumentAuditEvent.vue?vue&type=style&index=0&id=3c3714fe&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3714fe"]])

export default __exports__